import { useQueryClient } from '@tanstack/react-query';
import { subCategoryServices } from '../services/sub-category.service';

export const usePrefetchSubCategories = () => {
  const queryClient = useQueryClient();

  const prefetchNextPage = (filters, totalPages) => {
    const nextPage = parseInt(filters.page) + 1;
    if (nextPage <= totalPages) {
      queryClient.prefetchQuery({
        queryKey: ['sub-categories', { ...filters, page: String(nextPage) }],
        queryFn: () => subCategoryServices.getSubCategories({ ...filters, page: String(nextPage) }),
      });
    }
  };

  const prefetchPrevPage = (filters) => {
    const prevPage = parseInt(filters.page) - 1;
    if (prevPage >= 1) {
      queryClient.prefetchQuery({
        queryKey: ['sub-categories', { ...filters, page: String(prevPage) }],
        queryFn: () => subCategoryServices.getSubCategories({ ...filters, page: String(prevPage) }),
      });
    }
  };

  return { prefetchNextPage, prefetchPrevPage };
};
